<template>
  <div
    v-if="items.length"
    class="procedure-report-carrier-list">
    <v-tooltip
      bottom
      :disabled="items.length < 2">
      <template v-slot:activator="{ on, attrs }">
        <span
          class="procedure-report-carrier-list__name"
          v-bind="attrs"
          v-on="on">
          {{ firstName }}
        </span>
      </template>
      <span>{{ allNames }}</span>
    </v-tooltip>

    <v-menu
      v-if="items.length > 1"
      open-on-hover
      offset-y
      :close-on-content-click="false"
      transition="scale-transition"
      max-width="360">
      <template v-slot:activator="{ on, attrs }">
        <v-chip
          v-bind="attrs"
          v-on="on"
          small
          color="primary"
          class="procedure-report-carrier-list__chip">
          +{{ remainingItems.length }}
        </v-chip>
      </template>

      <v-card class="procedure-report-carrier-list__card">
        <v-list
          dense
          class="py-0 procedure-report-carrier-list__list">
          <v-list-item
            v-for="item in remainingItems"
            :key="item.id"
            class="px-2">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-list-item-content
                  class="py-1"
                  v-bind="attrs"
                  v-on="on">
                  <v-list-item-title class="text-body-2">
                    {{ item.name }}
                  </v-list-item-title>
                </v-list-item-content>
              </template>
              <span>{{ item.name }}</span>
            </v-tooltip>
          </v-list-item>
        </v-list>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
export default {
  name: 'ProcedureReportCarrierList',
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    firstName() {
      return this.items.length ? this.items[0].name : '';
    },
    remainingItems() {
      return this.items.slice(1);
    },
    allNames() {
      return this.items.map((item) => item.name).join('\n');
    },
  },
};
</script>

<style scoped>
.procedure-report-carrier-list {
  align-items: center;
  display: flex;
  flex-direction: row;
  gap: 6px;
  max-width: 100%;
  min-width: 0;
  width: 100%;
}

.procedure-report-carrier-list__name {
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.procedure-report-carrier-list__chip {
  flex: 0 0 auto;
}

.procedure-report-carrier-list__card {
  max-width: 360px;
}

.procedure-report-carrier-list__list {
  max-height: 240px;
  overflow-y: auto;
}
</style>
